import { Pipe, PipeTransform } from "@angular/core";
import { TerritoryRouteTypeColorsEnum, TerritoryRouteTypeEnum, TerritoryRouteTypeIconsEnum } from "../utilities/enums/TerritoriesEnum";

@Pipe({
    name: 'routeTypeIcon'
})
export class RouteTypeIconPipe implements PipeTransform {
    transform(routeType: string) {
        const RouteTypeIcon = TerritoryRouteTypeIconsEnum;
        const RouteType = TerritoryRouteTypeEnum;
        
        //busca el reouteColor usando la la key de routeType, si no encunetra el valor, intenta usar el key
        const routeTypeValues = Object.values(RouteType);
        const index = routeTypeValues.indexOf(routeType as TerritoryRouteTypeEnum);
        if (index !== -1) {
            const key = Object.keys(RouteType)[index];
            
            return RouteTypeIcon[key];
        }else{
            const routeTypeKeys = Object.keys(RouteType);
            routeTypeKeys.forEach(key => {
                key.replace(/_/g, ' ');           
            });
            const index = routeTypeKeys.indexOf(routeType as TerritoryRouteTypeEnum);
            if (index !== -1) {
                const key = Object.keys(RouteType)[index];
                return RouteTypeIcon[key];
            }
        }
        return 'territory_default.png';
    }
}